import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Locale from '../locale/en/ideasToBoostIncome';
import GlobalLocale from '../locale/en/global';
import ToolHeader from './ToolHeader';
import InputElementRouter from './InputElementRouter';
import ErrorPage from './ErrorPage';
import Loading from './Loading';
import useAxios from '../hooks';
import { getTotal } from '../helpers';

const IdeasToBoostIncome = ({ isLoggedIn }) => {
  document.title = Locale.title;
  const [answers, setAnswers] = useState({});

  const [{ returnedAnswers, isLoading, hasError }, refetchWithHttpVerb] = useAxios(
    answers,
    Locale.toolNumber,
    'get'
  );

  const postData = () => {
    refetchWithHttpVerb('post');
  };

  const deleteData = () => {
    refetchWithHttpVerb('delete');
  };

  useEffect(() => {
    setAnswers(returnedAnswers);
  }, [returnedAnswers]);

  if (hasError) { return <ErrorPage />; }
  if (isLoading) { return <Loading />; }

  return (
    <div className="ideas-to-boost-income">
      <div className="wrapper">
        <ToolHeader
          number={Locale.displayToolNumber}
          title={Locale.title}
          answers={answers}
          questions={Locale.numberOfQuestions}
          postData={postData}
          deleteData={deleteData}
        />
        <p className="tool-description">{Locale.description}</p>
      </div>
      <div className="ideas">
        {Locale.questions.map(question => (
          <div key={question.key} className="idea">
            <InputElementRouter
              question={question}
              setAnswers={setAnswers}
              answers={answers}
            />
          </div>
        ))}
        <div className="idea custom-title">
          {Locale.userGeneratedQuestions.map(question => (
            <div key={question.key}>
              <InputElementRouter
                question={question}
                setAnswers={setAnswers}
                answers={answers}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="wrapper">
        <div className="write-ideas">
          <div className="full-width-box">
            <div className="idea-title">{Locale.writtenIdeas}</div>
            {Locale.userGeneratedText.map(question => (
              <div key={question.key}>
                <InputElementRouter
                  question={question}
                  setAnswers={setAnswers}
                  answers={answers}
                />
              </div>
            ))}
          </div>
        </div>
        {isLoggedIn && (
          <div className="save-all">
            <button
              type="button"
              onClick={postData}
            >
              {GlobalLocale.saveAll}
            </button>
          </div>
        )}
        <div className="total-and-share">
          <div className="full-width-box">
            <div className="total">
              <div className="idea-title">{Locale.estimate}</div>
              <div className="idea-title total-amount">
                {getTotal(answers)}
              </div>
            </div>
            <div className="idea-description">{Locale.share}</div>
          </div>
        </div>
      </div>
      <div className="next">
        <Link
          className="small ghost"
          to="/en/ideas-to-reduce-expenses"
        >
          {GlobalLocale.nextTool}
        </Link>
        <button
          type="button"
          onClick={window.print}
        >
          {GlobalLocale.printAll}
        </button>
      </div>
    </div>
  );
};

IdeasToBoostIncome.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired
};

export default IdeasToBoostIncome;
